import { Kit } from '@repo/types';
import useFeature from 'services/features/useFeature';
import useSubscriptions from 'services/general/subscriptionsList';
import { usePortalConfigs } from './usePortalConfigs';

// Shared display condition for contextual Tiny+ upsell moments (ENG-4426):
// the kit must allow upsells, the account must have no active membership,
// and the rollout flag must be on.
export const useShowTinyPlusUpsell = (kit?: Kit | null) => {
  const { isFeatureEnabled } = useFeature('tiny_plus_upsell_moments');
  const { config, isLoading } = usePortalConfigs(kit);
  const { isAnyTinyPlus } = useSubscriptions();
  return (
    isFeatureEnabled && !isLoading && !config.hide_upsells && !isAnyTinyPlus
  );
};
